module.exports = __webpack_public_path__ + "img/border_bubble.23263031.svg";